import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { ElezioniComunali } from "./pages/ElezioniComunali";
import { ElezioniRegionali } from "./pages/ElezioniRegionali";
import { Storia } from "./pages/Storia";
import { Valori } from "./pages/Valori";
import { ElezioniTrasparenti } from "./pages/ElezioniTrasparenti";
import { ProgrammaRegionale } from "./pages/ProgrammaRegionale";
import { Unisciti } from "./pages/Unisciti";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/elezioni-comunali" element={<ElezioniComunali />} />
            <Route path="/elezioni-regionali" element={<ElezioniRegionali />} />
            <Route path="/storia" element={<Storia />} />
            <Route path="/valori" element={<Valori />} />
            <Route path="/elezioni-trasparenti" element={<ElezioniTrasparenti />} />
            <Route path="/programma-regionale" element={<ProgrammaRegionale />} />
            <Route path="/unisciti" element={<Unisciti />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
